<template>
  <v-app>
    <v-content>
      <v-container>
        <exhibition-view></exhibition-view>
      </v-container>
      <v-container>
        <exhibition-form></exhibition-form>
      </v-container>
      <v-container v-if="approvedBooths && approvedBooths.length > 0">
        <exhibition-logos></exhibition-logos>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import ExhibitionForm from "./components/ExhibitionForm";
import ExhibitionView from "./components/ExhibitionView";
import ExhibitionLogos from "./components/ExhibitionLogos.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "App",
  async created() {
    await this.getBooths();
  },
  components: {
    ExhibitionForm,
    ExhibitionView,
    ExhibitionLogos,
  },
  methods: {
    ...mapActions(["getBooths"]),
  },
  computed: {
    ...mapGetters(["approvedBooths"]),
  },
};
</script>
